import type { CityConfig } from "@/pages/city-template/types";

export const altoonaIaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates — Iowa HHS Vital Records", url: "https://hhs.iowa.gov/vital-records", desc: "Official Iowa vital records office in Des Moines" },
    { icon: "ri-heart-pulse-line", label: "Marriage Licenses — Polk County Recorder", url: "https://www.polkcountyiowa.gov/recorder/", desc: "Polk County Recorder — marriage license issuance" },
    { icon: "ri-scales-line", label: "Divorce Records — Polk County Clerk of Court", url: "https://www.iowacourts.gov/", desc: "Polk County Clerk of Court — divorce decree records" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", url: "https://www.vitalchek.com/", desc: "Official partner of Iowa HHS for online vital record orders" },
  ],
  city: "Altoona",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "altoona-ia",
  route: "/cities/altoona-ia",
  title: "Emergency & Expedited Passport Services Altoona IA | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Altoona, IA — as fast as 24 hours. No Altoona passport agency. Fast Passport Center couriers to the Chicago Passport Agency at 101 Ida B Wells Dr. A+ BBB rated. Serving Polk County families, Adventureland travelers, Prairie Meadows professionals, and Des Moines metro commuters.",
  h1: "Emergency & Expedited Passport Services in Altoona, IA",
  heroSubtitle: "Altoona is a thriving Des Moines suburb in Polk County, best known for Adventureland Resort and Prairie Meadows Casino. Fast Passport Center's registered couriers deliver your documents to the Chicago Passport Agency at 101 Ida B Wells Dr so you get a new or renewed passport as fast as 24 hours — whether you're an Altoona family planning a summer trip to Europe, a Prairie Meadows professional heading to an international conference, or a Des Moines metro resident needing a fast passport for last-minute travel from DSM.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Altoona%20Iowa%20suburban%20landscape%20with%20Adventureland%20amusement%20park%20roller%20coaster%20against%20blue%20sky%20in%20summer%2C%20green%20rolling%20hills%20of%20central%20Iowa%20Polk%20County%20landscape%20at%20golden%20hour%2C%20peaceful%20Des%20Moines%20suburb%20with%20residential%20neighborhoods%20and%20tree-lined%20streets%2C%20Midwest%20charm%20with%20warm%20sunlight&width=1800&height=700&seq=altoona-ia-hero-001&orientation=landscape",
  heroImageAlt: "Altoona Iowa suburban landscape with Adventureland and Polk County scenery at golden hour",
  geoPosition: "41.6489;-93.4647",
  geoPlacename: "Altoona, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, Chicago, IL 60605",
    distance: "Approximately 340 miles from Altoona — about 5 hours via I-80 and I-88",
  },
  nearbyCitiesZips: [
    { name: "Altoona", zips: "50009" },
    { name: "Des Moines", zips: "50309, 50310, 50311" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Pleasant Hill", zips: "50327" },
    { name: "Bondurant", zips: "50035" },
    { name: "Mitchellville", zips: "50169" },
    { name: "Runnells", zips: "50237" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Urbandale", zips: "50322, 50323" },
    { name: "Johnston", zips: "50131" },
    { name: "Clive", zips: "50325" },
    { name: "Newton", zips: "50208" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Chicago Passport Agency — serving Altoona and Polk County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Polk County & Des Moines Metro", desc: "Serving Altoona, Pleasant Hill, Bondurant, and the entire Des Moines metro" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Altoona case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Des Moines IA", route: "/cities/des-moines" },
    { name: "Expedited passport in Ankeny IA", route: "/cities/ankeny" },
    { name: "Urgent passport in Altoona IA", route: "/cities/altoona-ia" },
    { name: "Iowa passport hub", route: "/states/iowa" },
    { name: "Fast passport in West Des Moines IA", route: "/cities/west-des-moines" },
    { name: "Expedited passport in Urbandale IA", route: "/cities/urbandale" },
    { name: "Emergency passport in Iowa City IA", route: "/cities/iowa-city" },
  ],
  fpcOfficeAddress: "101 Ida B Wells Dr, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Altoona remotely via secure courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency at 101 Ida B Wells Dr — approximately 340 miles away. Altoona's location just east of Des Moines along I-80 with easy access to overnight shipping infrastructure makes courier routing highly reliable, and our dedicated agents ensure Polk County travelers never need to make the 5-hour drive to Chicago.",
  fpcOfficeDistance: "Serving all of Polk County and the Des Moines metro area",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Altoona, Pleasant Hill, Bondurant, Ankeny, Des Moines, and the greater Polk County area. From Adventureland-area families heading overseas to Prairie Meadows professionals traveling for business, we help central Iowans get their passports fast.",
  nearbyCitiesIntro: "We serve Altoona and nearby communities including Pleasant Hill, Bondurant, Mitchellville, Ankeny, Des Moines, and the entire Des Moines metropolitan area.",
  howItWorksIntro: "Most Altoona travelers complete everything online and ship documents overnight. Fast Passport Center provides fast courier turnaround for Polk County residents — eliminating the 5-hour drive to the Chicago Passport Agency.",
  mistakesIntro: "Altoona travelers, including Des Moines metro commuters, Adventureland-area families, and Prairie Meadows professionals, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Altoona and Polk County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Altoona? Here are the most common ones we hear from Polk County and Des Moines metro travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Altoona families traveling abroad",
        "Perfect for Des Moines metro professionals",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from DSM",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 101 Ida B Wells Dr",
        "Life-or-death emergencies only",
        "340 miles to Chicago (5 hours via I-80 and I-88)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Altoona is 340 miles from the Chicago Passport Agency — our courier service saves Polk County travelers the I-80 drive to Chicago.",
      bullets: ["Des Moines metro coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Central Iowa",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Altoona adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Altoona and Polk County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Altoona and Polk County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Altoona, Pleasant Hill, and Polk County residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Chicago agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Polk County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Altoona and Polk County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Altoona IA", description: "Urgent passport processing for Altoona, IA travelers via Chicago Passport Agency courier." },
    { name: "Passport Renewal Altoona IA", description: "Fast passport renewal for Altoona and Polk County, Iowa residents." },
    { name: "New Passport Altoona IA", description: "First-time passport application assistance for Altoona and Des Moines metro area residents." },
    { name: "Lost Passport Altoona IA", description: "Passport replacement for lost or stolen passports for Altoona and central Iowa residents." },
    { name: "Child Passport Altoona IA", description: "Minor passport services for Altoona and Polk County families." },
    { name: "Name Change Passport Altoona IA", description: "Passport name change service for Altoona, IA residents." },
  ],
  testimonials: [
    {
      name: "Mark & Susan D.",
      location: "Altoona — near Adventureland",
      rating: 5,
      text: "Altoona family of four planning a summer trip to London and Paris. Realized 3 weeks out that our youngest needed a first-time passport and mine was expired. Fast Passport Center handled everything — renewal in 4 days, first-time passport for our daughter in 7 days. The dedicated agent kept us informed the whole way. We made the trip and had an amazing time.",
      service: "Family Passport Applications",
    },
    {
      name: "Brenda K.",
      location: "Des Moines — Prairie Meadows Professional",
      rating: 5,
      text: "Convention sales manager at Prairie Meadows called to an international gaming industry conference in Macau on 10 days notice. Passport had less than 3 months of validity. Fast Passport Center expedited the renewal in 3 business days. Professional service that understood the urgency — I didn't miss a single meeting.",
      service: "Emergency Business Renewal",
    },
    {
      name: "The Williams Family",
      location: "Altoona — Southeast Polk School District",
      rating: 5,
      text: "Altoona family with a high school student going on a school trip to Spain. Realized 2 weeks before departure that the passport application had never been submitted. Fast Passport Center got the first-time passport processed in 5 business days through their Chicago courier. Our son made the trip with his class — we're so grateful.",
      service: "Student Travel Emergency",
    },
    {
      name: "Robert J.",
      location: "Pleasant Hill, IA — retired engineer",
      rating: 5,
      text: "Retired John Deere engineer who lost his passport during a move from Altoona to Pleasant Hill. Had a river cruise in Europe booked 3 weeks out. Fast Passport Center helped with the DS-64 lost passport form and got the replacement processed through Chicago in 4 business days. I was on that Danube cruise without a single worry.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "alt-1",
      name: "Altoona Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 1st Ave S",
      city: "Altoona",
      state: "IA",
      zip: "50009",
      phone: "(515) 967-4214",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Altoona — 1st Avenue South",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary passport acceptance facility for Altoona and eastern Polk County residents. Appointment required. Located near downtown Altoona on 1st Avenue South.",
      icon: "ri-mail-line",
    },
    {
      id: "alt-2",
      name: "Pleasant Hill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1345 NE 56th St",
      city: "Pleasant Hill",
      state: "IA",
      zip: "50327",
      phone: "(515) 266-1225",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pleasant Hill — 4 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Altoona residents in western and southern neighborhoods. Located near the Altoona-Pleasant Hill border. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "alt-3",
      name: "Ankeny Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1011 N Ankeny Blvd",
      city: "Ankeny",
      state: "IA",
      zip: "50023",
      phone: "(515) 964-4767",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Ankeny — 12 miles northwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger post office serving northern Polk County. Convenient for Altoona residents near the I-80 corridor heading west. Extended afternoon hours compared to some facilities.",
      icon: "ri-mail-line",
    },
    {
      id: "alt-4",
      name: "Des Moines Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1165 2nd Ave",
      city: "Des Moines",
      state: "IA",
      zip: "50318",
      phone: "(515) 283-7581",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM, Sat: 9:00 AM – 12:00 PM",
      distance: "Des Moines — 12 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest USPS facility in the Des Moines metro with Saturday passport hours. About 15 minutes from Altoona via I-235. Offers the most appointment availability in the region.",
      icon: "ri-mail-line",
    },
    {
      id: "alt-5",
      name: "Bondurant Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "85 Paine St SE",
      city: "Bondurant",
      state: "IA",
      zip: "50035",
      phone: "(515) 967-5911",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bondurant — 5 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Smaller facility serving Bondurant and northern Altoona residents. Less busy than Des Moines metro locations. Call ahead as hours may vary.",
      icon: "ri-mail-line",
    },
    {
      id: "alt-6",
      name: "Polk County Recorder's Office",
      type: "County Government Passport Acceptance",
      address: "111 Court Ave, Room 245",
      city: "Des Moines",
      state: "IA",
      zip: "50309",
      phone: "(515) 286-3160",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Des Moines — 12 miles west",
      website: "https://www.polkcountyiowa.gov/recorder/",
      websiteLabel: "Polk County Recorder",
      notes: "County government passport acceptance facility in downtown Des Moines. Often has more appointment availability than post office locations. Convenient for Altoona commuters working downtown.",
      icon: "ri-building-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Chicago Agency", agency: "340 miles — 5 hour drive via I-80/I-88, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-road-map-line",
      title: "Thinking Chicago Is a Quick Drive — It's a 10-Hour Round Trip",
      description: "At 340 miles, Altoona residents considering driving to the Chicago Passport Agency at 101 Ida B Wells Dr face a 10-hour round trip — and even then, the agency requires a pre-scheduled NPIC appointment. Appointments fill weeks in advance during peak summer travel season when Des Moines metro families are booking vacations.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When DS-11 In-Person Is Required",
      description: "Altoona residents with passports that expired more than 5 years ago, were issued under age 16, or have a name change without proper documentation must apply in person using Form DS-11 — not the mail-in DS-82. Using the wrong form is the number one reason for rejected applications, causing weeks of delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Waiting Until After the Iowa State Fair to Start Passport Planning",
      description: "Many Des Moines metro families plan their international summer travel around the Iowa State Fair in August, then realize in June or July that passports are needed. The State Department's busiest processing months are March through August — waiting until after school ends means competing with the entire country for limited passport appointments and processing capacity.",
    },
    {
      icon: "ri-image-line",
      title: "Using Drugstore Photos That Don't Meet Official Requirements",
      description: "Altoona residents often get passport photos from local chain pharmacies where staff may not be specifically trained on State Department specifications. Photos must be exactly 2x2 inches with a pure white background, neutral expression centered in frame, and no glasses. Even minor deviations cause the entire application to be rejected.",
    },
    {
      icon: "ri-global-line",
      title: "Not Knowing About the 6-Month Passport Validity Rule",
      description: "Many central Iowans book international flights from DSM without checking their passport expiration date. Most countries require at least 6 months of validity beyond your planned return date. An Altoona traveler with a passport expiring in 4 months will be denied boarding for a trip to Europe or Asia — even with a valid ticket.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming Des Moines Has a Passport Agency",
      description: "A common misconception among Altoona and Des Moines metro residents is that Des Moines has a regional passport agency because it's the state capital. It does not. The closest agency is in Chicago, 340 miles away. Des Moines only has passport acceptance facilities — post offices and county offices that accept applications but cannot process or expedite them.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Altoona, Pleasant Hill, or Des Moines." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Chicago Passport Agency — 340 miles via I-80 and I-88." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Chicago Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Altoona or Polk County address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Altoona from the Chicago passport agency?",
      a: "Altoona is approximately 340 miles from the Chicago Passport Agency at 101 Ida B Wells Dr — about a 5 hour drive via I-80 east to I-88 east into Chicago. Altoona's location right on I-80 gives central Iowa travelers direct freeway access, but the Chicago agency requires pre-scheduled NPIC appointments and absolutely no walk-ins are accepted. A round trip to Chicago for a passport appointment is a 10-hour commitment.",
    },
    {
      q: "Does Altoona, IA have its own passport agency?",
      a: "No. Altoona does not have a passport agency and neither does Des Moines or anywhere in Iowa. The closest regional passport agency is the Chicago Passport Agency at 101 Ida B Wells Dr, about 340 miles away. Altoona has a passport acceptance facility at the Altoona Post Office on 1st Avenue South, but acceptance facilities can only accept DS-11 applications — they cannot process or expedite passports.",
    },
    {
      q: "Where do Altoona travelers typically fly internationally?",
      a: "Altoona residents primarily use Des Moines International Airport (DSM), about 15–20 minutes west via I-235. DSM offers domestic connections to all major hubs including Chicago O'Hare, Dallas-Fort Worth, Denver, Minneapolis, and Atlanta, making international connections straightforward. Some central Iowans also drive to Kansas City International (MCI, about 3 hours) or Minneapolis-Saint Paul (MSP, about 3.5 hours) for more direct international flights.",
    },
    {
      q: "How fast can I get an emergency passport in Altoona?",
      a: "Emergency processing is typically 24–48 hours for Altoona residents. Altoona's location in the Des Moines metro with access to major overnight shipping hubs makes courier routing highly reliable via I-80 to Chicago. Standard expedited processing runs 2–9 business days. Our courier service eliminates the need for a 10-hour round trip to Chicago.",
    },
    {
      q: "Where can I get passport photos in Altoona?",
      a: "Walgreens at 3414 8th St SW in Altoona, Walmart Supercenter at 3501 8th St SW, and nearby CVS Pharmacy locations in Pleasant Hill and Des Moines offer passport photo services. The UPS Store on SE Delaware Avenue in Ankeny also provides photos. Always verify photos meet exact 2x2 inch specifications with a pure white background before submitting.",
    },
    {
      q: "Does the Altoona Post Office take walk-in passport appointments?",
      a: "The Altoona Post Office at 300 1st Ave S accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (515) 967-4214 to schedule. This location serves eastern Polk County and suburban Altoona, and can fill up quickly during spring and summer.",
    },
    {
      q: "Can the Polk County Recorder's Office process my passport?",
      a: "Yes. The Polk County Recorder's Office at 111 Court Ave in downtown Des Moines offers passport acceptance services Monday through Friday from 8:00 AM to 4:30 PM. This county government facility often has more appointment slots than nearby post offices and opens an hour earlier. It's about 15 minutes from Altoona and convenient for those working in Des Moines.",
    },
    {
      q: "I'm an Altoona family with Adventureland season passes — when should we start passport planning?",
      a: "Altoona families planning international travel should start passport applications at least 4–6 months before departure. The summer season — when Adventureland is at peak operation and families coordinate vacations around school schedules — is also the State Department's busiest passport processing period. Starting early ensures your family's passports are ready well before travel dates.",
    },
    {
      q: "Can Fast Passport Center help Pleasant Hill and Bondurant residents too?",
      a: "Absolutely. We serve all of eastern Polk County including Altoona, Pleasant Hill, Bondurant, Mitchellville, Runnells, and the entire Des Moines metropolitan area. Residents of these communities never need to drive to Altoona or Chicago for expedited passport service — everything is handled via secure overnight courier.",
    },
    {
      q: "Is there an acceptance facility near Altoona with Saturday hours?",
      a: "Yes. The Des Moines Main Post Office at 1165 2nd Ave offers Saturday passport acceptance from 9:00 AM to 12:00 PM — the only Saturday passport option in the Des Moines metro. It's about 15 minutes from Altoona via I-235. The Altoona, Pleasant Hill, and Bondurant post offices do not offer Saturday hours.",
    },
    {
      q: "How do I renew my passport in Altoona?",
      a: "Adult renewals meeting DS-82 eligibility (16 or older at issuance, passport issued within last 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service to Chicago achieves 2–9 business day turnaround — dramatically faster than standard USPS mail (8–11 weeks). If you don't qualify for mail-in renewal, visit the Altoona Post Office or Polk County Recorder's Office for DS-11 in-person service.",
    },
    {
      q: "What's the closest place to Altoona with a REAL ID DMV for passport-related ID?",
      a: "The Iowa DOT office nearest Altoona is the Ankeny Driver's License Service Center at 6310 SE Convenience Blvd in Ankeny, about 12 miles northwest. For REAL ID-compliant driver's licenses — which are increasingly important as the REAL ID enforcement deadline approaches — visit any Iowa DOT full-service location. A REAL ID can serve as identification for passport applications, though a passport itself also qualifies for REAL ID purposes.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Altoona", address: "3414 8th St SW, Altoona, IA 50009", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Altoona", address: "3501 8th St SW, Altoona, IA 50009", hours: "Mon–Sun: 7AM–9PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Pleasant Hill", address: "1100 NE 56th St, Pleasant Hill, IA 50327", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Des Moines (East Euclid)", address: "2303 E Euclid Ave, Des Moines, IA 50317", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Ankeny", address: "1555 SE Delaware Ave, Ankeny, IA 50021", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Des Moines (Ingersoll)", address: "2301 Ingersoll Ave, Des Moines, IA 50312", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "Iowa DOT — Ankeny Driver's License Service Center", address: "6310 SE Convenience Blvd, Ankeny, IA 50021", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Nearest Iowa DOT full-service driver's license center to Altoona. About 12 miles via I-35. REAL ID, driver's license, and state ID services. Appointment recommended.", featured: true },
    { name: "Iowa DOT — Des Moines Service Center", address: "6310 Douglas Ave, Des Moines, IA 50310", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Downtown Des Moines driver's license center. Full service including REAL ID. About 15 minutes from Altoona via I-235.", featured: false },
    { name: "Polk County Treasurer — Motor Vehicle", address: "111 Court Ave, Des Moines, IA 50309", hours: "Mon–Fri: 8:00AM–4:30PM", note: "County motor vehicle registration and titling services. Note: driver's license services are handled by Iowa DOT, not the county.", featured: false },
  ],
  airports: [
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "12 miles west of Altoona",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "The primary airport serving Altoona and central Iowa. About 15–20 minutes via I-235. Domestic connections to all major hubs including Chicago O'Hare, Dallas-Fort Worth, Denver, Minneapolis, and Atlanta for international connections. Growing passenger numbers with expanded service.",
      flightUrl: "https://www.flydsm.com/",
      flightLabel: "DSM Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport (Cedar Rapids)",
      distance: "110 miles east of Altoona",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Iowa's second-busiest airport serving eastern Iowa. About 1 hour 45 minutes via I-80. Domestic routes with connections to major hubs. Alternative for eastern Polk County residents.",
      flightUrl: "https://www.flycid.com/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "190 miles south of Altoona",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major regional hub with more international direct flight options than DSM. About 3 hours via I-35. Southwest Airlines focus city with extensive domestic and growing international routes.",
      flightUrl: "https://flykc.com/",
      flightLabel: "MCI Airport",
      featured: false,
    },
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "250 miles north of Altoona",
      address: "4300 Glumack Dr, St Paul, MN 55111",
      note: "Major Delta Air Lines hub with extensive international connections to Europe, Asia, and beyond. About 3.5 hours via I-35. The closest major international gateway to central Iowa for transoceanic flights.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport",
      featured: false,
    },
  ],
};